import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    open: false,
    myStatus: false,
    companyCode: '',
    branchCode: '',
    unitName: '',
    menu: null,
    error: null,
    loading: false,
};


const headerSlice = createSlice({
    name: 'headerSlice',
    initialState,
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setMyStatus: (state, action) => {
            state.myStatus = action.payload
        },
        setCompanyCode: (state, action) => {
            state.companyCode = action.payload;
        },
        setActiveClass: (state, action) => {
            state.activeClass = action.payload
        },
        setBranchCode: (state, action) => {
            state.branchCode = action.payload;
        },
        setUnitName: (state, action) => {
            state.unitCode = action.payload;
        }
    }
});

export const { setOpen, setCompanyCode, setMyStatus, setActiveClass, setBranchCode, setUnitName } = headerSlice.actions

export default headerSlice.reducer
